import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TransmissionRunActions, TransmissionRunActionTypes } from './transmission-run.actions';
import { TransmissionRunEntity } from './transmission-run.model';

export interface TransmissionRunEntities extends EntityState<TransmissionRunEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<TransmissionRunEntity> = createEntityAdapter<
  TransmissionRunEntity
>();

export const initialState: TransmissionRunEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): TransmissionRunEntities {
  const action = incomingAction as TransmissionRunActions;
  switch (action.type) {
    case TransmissionRunActionTypes.AddTransmissionRun: {
      return adapter.addOne(action.payload.transmissionRun, state);
    }

    case TransmissionRunActionTypes.UpsertTransmissionRun: {
      return adapter.upsertOne(action.payload.transmissionRun, state);
    }

    case TransmissionRunActionTypes.AddTransmissionRuns: {
      return adapter.addMany(action.payload.transmissionRuns, state);
    }

    case TransmissionRunActionTypes.UpsertTransmissionRuns: {
      return adapter.upsertMany(action.payload.transmissionRuns, state);
    }

    case TransmissionRunActionTypes.UpdateTransmissionRun: {
      return adapter.updateOne(action.payload.transmissionRun, state);
    }

    case TransmissionRunActionTypes.UpdateTransmissionRuns: {
      return adapter.updateMany(action.payload.transmissionRuns, state);
    }

    case TransmissionRunActionTypes.DeleteTransmissionRun: {
      return adapter.removeOne(action.payload.id, state);
    }

    case TransmissionRunActionTypes.DeleteTransmissionRuns: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case TransmissionRunActionTypes.LoadTransmissionRuns: {
      return adapter.setAll(action.payload.transmissionRuns, state);
    }

    case TransmissionRunActionTypes.ClearTransmissionRuns: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
